var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPermanent = function SvgPermanent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1722,
    height: 850,
    viewBox: "-10 0 1722 850"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1334 0q106 0 192.5 52t136 147 49.5 214q0 124-51 223.5T1516 793t-214 57q-77 0-147-23t-130.5-67.5-108-91.5T816 556Q621 850 369 850q-107 0-193.5-52.5t-136-147T-10 437q0-124 51-223.5T186.5 57 401 0q76 0 146 23t131 67.5T786 182t101 112Q1081 0 1334 0M391 699h-1q60 0 108.5-13t92.5-42 81.5-66 84.5-95q-43-55-75.5-93T607 310.5 528.5 244 449 202.5 364 186q-117 0-184.5 67T112 425q0 119 80.5 196.5T391 699m948-35q116 0 183.5-67t67.5-172q0-119-80.5-196.5T1312 151q-60 0-108.5 13t-92.5 42-81.5 66-84.5 95q43 54 75.5 92.5t74.5 80 78.5 66.5 79.5 41.5 86 16.5"
  })));
};
export default SvgPermanent;